import "./product-details-bulk-buyer-modal.scss";

const $getModalTrigger = () => document.querySelector(".js-bulk-buyer-modal-trigger");
const $getBulkSummaryTable = () => document.querySelector(".js-pdp-bulk-discount-summary-table");
const $getModalContent = () => document.querySelector(".js-bulk-buyer-modal-content");
const $$getBulkBuyerModal = () => $(".js-bulk-buyer-modal");

const $getTableSpacer = $container => $container.querySelector(".js-bulk-table-spacer");

document.addEventListener("DOMContentLoaded", () => {
  const $bulkSummaryTable = $getBulkSummaryTable();
  const $modalContent = $getModalContent();
  const $modalTrigger = $getModalTrigger();

  if (!$bulkSummaryTable || !$modalTrigger) return;

  $modalTrigger.classList.remove("hidden");

  $modalTrigger.addEventListener("click", () => {
    if (!$modalContent.hasChildNodes()) {
      $modalContent.appendChild($bulkSummaryTable.cloneNode(true));
      const $tableSpacer = $getTableSpacer($modalContent);
      $tableSpacer?.classList.add("hidden");
    }

    $$getBulkBuyerModal().modal("show");
  });
});
